import { apiUrl }  from "../constants";
var axios = require('axios');
var request = axios.create({
    baseURL: apiUrl,
    headers: {'Authorization':localStorage.getItem('token'),'Content-Type':'application/json'}
})
export default class TournamentsApi {
    static getAll(tournament=null) {
        console.log(localStorage.getItem("rol"))
        return request.get(`/tournaments/${localStorage.getItem("rol")}/${tournament}`);
    }

    static get(id,tournament) {
        return request.get(`/tournaments/${localStorage.getItem("rol")}/${tournament}/${id}`);
    }

    static create(tournament) {
        return request.post('/tournaments',{tournament: tournament });
    }

    static edit(tournament, id){
        return request.put(`/tournaments/${id}`, {tournament: tournament});
    }

    static delete(id){
        return request.delete(`tournaments?id=${id}`);
    }
}


// WEBPACK FOOTER //
// ./src/api/Tournaments.js